import React from "react";
import { useHistory } from "react-router-dom";
import BigLogo from "assets/images/sellix_logo.svg";
import BigLogoWhite from "assets/images/sellix_logo_white.svg";
import SmallLogo from "assets/images/loader_logo_dark.svg";
import SmallLogoWhite from "assets/images/loader_logo_light.svg";
import WinterBigLogo from "assets/images/winter-white.png";
import PaylixSmallLogoDark from "assets/images/paylix_logo_small_black.svg"
import PaylixSmallLogoLight from "assets/images/paylix_logo_small_white.svg"
import PaylixBigLogoLight from "assets/images/paylix_logo_big_white.svg"
import WinterDarkBigLogo from "assets/images/winter.svg";
import { useDispatch, useSelector } from "react-redux";
import { redirectToSubLink } from "../../subdomainLink";
import { toggleNav } from "../../../entrypoints/dashboard/layouts/dashboard/actions";
import { Minimize } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../../hooks/useMobile";
import useTheme from "../../../hooks/useTheme";

import "../style.scss";

// #7A5ADF
const Logo = ({ mobile, isDashboard, isAdmin }) => {

	const open = useSelector(({ nav }) => nav.open );
	const isDark = useTheme();
	const isMobile = useMobile();
	const history = useHistory();
	const dispatch = useDispatch();

	const isWinter = false;

	return (
		<div className={`header-logo-image ${!open && 'open'} ${mobile && 'mobile'}`}>
			<div onClick={() => {
				isDashboard ?
					history.push('/') :
					redirectToSubLink('', '/')
			}}>
				<img src={isDark ? PaylixSmallLogoDark : PaylixSmallLogoLight} width="27" height="48" alt="paylixecommerce" className="header-logo-image-small"
					 style={(isWinter && isDark) ? {
						 top: 18,
					 } : {}}
				/>


				{
					isWinter ?
						isDark ?
							<img src={WinterBigLogo} width="87" height="29" alt="paylixecommerce" className="header-logo-image-big" style={isMobile ? { top: -6, left: "auto", transform: "scale(1.5)", position: "relative" } : { top: -5, left: -10, position: "relative" }}/>
							:
							<img src={isDark ? BigLogoWhite : BigLogo} width="70" height="20" alt="paylixecommerce" className="header-logo-image-big" />
							:
							<img src={isDark ? PaylixBigLogoLight : BigLogo} width="70" height="20" alt="paylixecommerce" className="header-logo-image-big" />
				}
		</div>

			{
				((isDashboard || isAdmin) && open && !isMobile) ? <div className="sidebar-minimized-icon" onClick={() => dispatch(toggleNav(!open))} id="minimized">
					<Minimize />
				</div> : null
			}
		</div>
	);
}


export default Logo;
